import {persistStore, persistReducer, createTransform} from 'redux-persist';
import AsyncStorage from '@react-native-async-storage/async-storage';
import rootReducer from '../Reducers';
import {configureStore as ReduxStore} from '@reduxjs/toolkit';

// Strip error state on rehydration so a background API failure from a previous
// session doesn't show an error screen on the next app start when cached data exists.
const clearErrorTransform = createTransform(
  inboundState => inboundState,
  outboundState => ({
    ...outboundState,
    error: false,
    errorMessage: '',
  }),
  {whitelist: ['deviceConfigSlice', 'hotelLangSlice', 'serverDateTimeSlice', 'hotelSelectorSlice']},
);

/**
 *
 * @returns
 */
const configureStore = () => {
  const persistConfig = {
    key: 'root',
    storage: AsyncStorage,
    whitelist: ['appPreservedConfigSlice', 'deviceConfigSlice', 'hotelLangSlice', 'serverDateTimeSlice', 'guestDetailsSlice', 'hotelSelectorSlice', 'dynamicStyleSlice', 'countryListtSlice', 'documentListSlice', 'notificationSlice', 'translationSlice' ],
    transforms: [clearErrorTransform],
    // Throttle persist writes to reduce storage operations
    throttle: 1000,
  };

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = ReduxStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false,
        // Disable immutability checks in production for better performance
        immutableCheck: process.env.NODE_ENV !== 'production',
      }),
  });

  let persistor = persistStore(store);

  return {store, persistor};
};
export default configureStore;
